import React, { useEffect } from "react";
import { Divider, Button, Table, Grid } from "antd";
import * as XLSX from "xlsx";
const SimpleTable = ({
  data,
  columns,
  width,
  tableName,
  pageSize,
  selection,
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
  };

  let selectionType = null;

  if (selection) {
    selectionType = {
      type: "checkbox",
      ...rowSelection,
    };
  }

  return (
    <div>
      <div className={width}>
        <div style={{ borderColor: "#222D32" }} className="box">
          <div className="box-header with-border">
            <h3 id="response" className="box-title">
              {tableName}
            </h3>
            <div className="box-tools pull-right">
              {/* <button
                type="button"
                className="btn btn-box-tool"
                title="Refresh"
                onclick="refreshMyTable()"
              >
                <i className="fa fa-refresh" />
              </button>
              <button type="submit" className="btn btn-default">
                <i className="fa fa-search" />
              </button> */}
            </div>
            <div className="box-body">
              {isMobile ? (
                // Mobile card layout
                <div className="mobile-card-list">
                  {data?.map((item, index) => (
                    <div key={item.id || index} className="mobile-card-item">
                      <div className="mobile-card-header">
                        <span>{item.name || item.title || `Item ${index + 1}`}</span>
                        {item.status && (
                          <span className={`badge ${item.status === 'active' ? 'badge-success' : 'badge-secondary'}`}>
                            {item.status}
                          </span>
                        )}
                      </div>
                      <div className="mobile-card-content">
                        {columns.slice(0, 4).map((col) => (
                          <div key={col.key || col.dataIndex} className="mobile-card-field">
                            <div className="mobile-card-label">{col.title}</div>
                            <div className="mobile-card-value">
                              {col.render ? col.render(item[col.dataIndex], item) : item[col.dataIndex]}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                // Desktop table layout
                <div className="responsive-table-container">
                  <Table
                    rowKey="id"
                    rowSelection={selectionType}
                    columns={columns}
                    dataSource={data}
                    pagination={{
                      pageSize: pageSize,
                      total: data.length,
                      showSizeChanger: false,
                      showQuickJumper: false,
                    }}
                    showSorterTooltip={{
                      target: "sorter-icon",
                    }}
                    scroll={{ x: true }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleTable;
